export const APPLICATION_READY_STORAGE_KEY = 'enrollment-application-ready-at'

export const enrollmentDraftStorageKeys = [
  'quoteToken',
  'firstName',
  'lastName',
  'middleName',
  'email',
  'phone',
  'phoneNumber',
  'birthDate',
  'dateOfBirth',
  'address',
  'addressLine1',
  'addressLine2',
  'city',
  'state',
  'zipCode',
  'selected-location-external-id',
  'selected-location-state',
  'selected-program-external-id',
  'selected-program-yard-only',
  'selected-program-class-only',
  'contactExternalId',
  APPLICATION_READY_STORAGE_KEY
] as const

export type EnrollmentDraftStorageKey = (typeof enrollmentDraftStorageKeys)[number]
